import request from '../utils/request';
import type {
  AdminDashboard,
  EmployeesResponse,
  CreateEmployeeRequest,
  EmployeeResponse,
  DatasetsResponse,
  CreateDatasetRequest,
  DatasetResponse,
  PhoneRecordsResponse,
  CreateManualEntryRequest,
  ManualEntryResponse,
  ManualEntriesResponse,
  AdminManualEntryStats,
  ManualEntryEmployeesStats,
} from '../types';

export const adminService = {
  // 获取仪表板数据
  getDashboard: (): Promise<AdminDashboard> => {
    return request.get('/admin/dashboard');
  },

  // 员工管理
  getEmployees: (params?: {
    page?: number;
    per_page?: number;
  }): Promise<EmployeesResponse & { pagination?: any }> => {
    return request.get('/admin/employees', { params });
  },

  createEmployee: (data: CreateEmployeeRequest): Promise<EmployeeResponse> => {
    return request.post('/admin/employees', data);
  },

  deleteEmployee: (employeeId: number): Promise<{ message: string }> => {
    return request.delete(`/admin/employees/${employeeId}`);
  },

  // 数据集管理
  getDatasets: (params?: {
    page?: number;
    per_page?: number;
  }): Promise<DatasetsResponse & { pagination?: any }> => {
    return request.get('/admin/datasets', { params });
  },

  createDataset: (data: CreateDatasetRequest): Promise<DatasetResponse> => {
    return request.post('/admin/datasets', data);
  },

  deleteDataset: (datasetId: number): Promise<{ message: string }> => {
    return request.delete(`/admin/datasets/${datasetId}`);
  },

  getDatasetRecords: (datasetId: number, params?: {
    page?: number;
    per_page?: number;
    uploader?: string;
    phone_number?: string;
    start_date?: string;
    end_date?: string;
  }): Promise<PhoneRecordsResponse> => {
    return request.get(`/admin/datasets/${datasetId}/records`, { params });
  },

  // 手动入库相关API
  createManualEntry: (data: CreateManualEntryRequest): Promise<ManualEntryResponse> => {
    return request.post('/admin/manual-entry', data);
  },

  getManualEntries: (params?: {
    page?: number;
    per_page?: number;
    employee_id?: number;
    dataset_id?: number;
  }): Promise<ManualEntriesResponse> => {
    return request.get('/admin/manual-entries', { params });
  },

  getManualEntryStats: (employeeId?: number): Promise<AdminManualEntryStats> => {
    const params = employeeId ? { employee_id: employeeId } : undefined;
    return request.get('/admin/manual-entry-stats', { params });
  },

  getManualEntryEmployeesStats: (): Promise<ManualEntryEmployeesStats> => {
    return request.get('/admin/manual-entry-stats/employees');
  },

  // 获取所有上传任务（管理员专用）
  getAllUploadTasks: (params?: {
    page?: number;
    per_page?: number;
  }): Promise<{ upload_tasks: any[]; pagination?: any }> => {
    return request.get('/admin/all-uploads', { params });
  },

  // 获取所有上传任务（仪表板专用，无分页限制）
  getAllUploadTasksUnlimited: (): Promise<{ upload_tasks: any[] }> => {
    return request.get('/admin/all-uploads-unlimited');
  },

  // 获取我的上传任务（管理员）
  getMyUploads: (params?: {
    page?: number;
    per_page?: number;
  }): Promise<{ upload_tasks: any[]; records: any[]; pagination?: any }> => {
    return request.get('/admin/my-uploads', { params });
  },
};
